export default "__VITE_ASSET__US6D1ojN__"